/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {combineReducers} from '@reduxjs/toolkit';

import {vehicleSeriesDefinitionReducer} from '../vehicleSeriesDefinition/reducer';

export const vehicleSettingsReducer = combineReducers({
  vehicleSeriesDefinition: vehicleSeriesDefinitionReducer,
});
